import pdpSlider from "./rbmc.pdp-slider";
import 'slick-carousel';
import 'jquery.panzoom';

const pdpZoom = {
    pageBody:                     undefined,
    zoomOverlay:                  undefined,
    closeButton:                  undefined,
    slickSlider:                  undefined,
    panArea:                      undefined,
    panImage:                     undefined,
    openPanButton:                undefined,
    zoomInButton:                 undefined,
    zoomOutButton:                undefined,
    panOverlay:                   undefined,
    isArchibaldPdp:               undefined,
    zoomImageSources:             [],
    archibaldGalleryItems:        undefined,
    archibaldGalleryClickedIndex: undefined,
    cacheSelectors() {
        this.pageBody       = $('body');
        this.isArchibaldPdp = !!this.pageBody.find('.archibaldPDP').length;
        this.zoomOverlay    = $('#js-pdp-zoom__overlay');
        this.closeButton    = $('#js-pdp-zoom__close');
        this.slickSlider    = $('#js-pdp-zoom__slider');
        this.panArea        = $('#js-pdp-pan__area');
        this.panImage       = $('#js-pdp-pan__image');
        this.panOverlay     = $('#js-pdp-pan__overlay');
        this.openPanButton  = $('#js-pdp-zoom__open-pan');
        this.zoomInButton   = $('#js-pdp-zoom__zoom-in');
        this.zoomOutButton  = $('#js-pdp-zoom__zoom-out');

        if (this.isArchibaldPdp) {
            this.archibaldGalleryItems = this.pageBody.find('.pdp__slider-image--zoom');
        }
    },

    showZoomOverlay() {
        this.zoomOverlay.addClass('pdp-zoom__overlay--active');
        this.pageBody.addClass('disable-overflow');
    },

    hideZoomOverlay() {
        this.zoomOverlay.removeClass('pdp-zoom__overlay--active');
        this.pageBody.removeClass('disable-overflow');
    },

    showPanOverlay() {
        this.panOverlay.addClass('pdp-pan__overlay--active');
        this.panArea.panzoom({
            contain:    'invert',
            startScale: 1.25,
            minScale:   1,
            maxScale:   4,
            increment:  0.25,
            duration:   150
        }).panzoom('zoom');
    },

    hidePanOverlay() {
        this.panArea.panzoom('reset');
        this.panArea.panzoom('destroy');
        this.panArea.attr('style', '');
        this.panOverlay.removeClass('pdp-pan__overlay--active');
    },

    extractImageSources() {
        if (!this.isArchibaldPdp) {
            pdpSlider.pdpSliderWrapper.slick('getSlick').$slides.each((index, slide) => {
                let $slide = $(slide);
                let imageSource;

                if ($slide.find('.pdp__slider-video').length) {
                    return;
                }

                imageSource = $slide.find('.pdp__slider-image--zoom').data('zoomSrc');
                this.zoomImageSources.push(this.replaceSrc(imageSource));

            });
        } else {
            this.archibaldGalleryItems.each((index, elem) => {
                const src = $(elem).data('src');
                this.zoomImageSources.push(this.replaceSrc(src));
            });
        }
    },

    replaceSrc(src) {
        return src.replace(`${RedBull.config.cloudinaryAssetDetailPrefix}`, `${RedBull.config.cloudinaryAssetZoomPrefix}`)
    },

    getClickedGalleryIndex(){
        return !pdpZoom.isArchibaldPdp ? pdpSlider.pdpSliderWrapper.slick('slickCurrentSlide')
                : pdpZoom.archibaldGalleryClickedIndex
    },

    createZoomSlide(imgSrc) {
        return `<div class="pdp-zoom__slide"><img class="pdp-zoom__image" src="${imgSrc}"></div>`;
    },

    addZoomSlides() {
        for (let src of this.zoomImageSources) {
            this.slickSlider.append(this.createZoomSlide(src));
        }
    },

    initPanImage() {
        this.panImage.attr('src', this.zoomImageSources[this.getClickedGalleryIndex()] ?? 0);
    },

    buildSlickSlider() {
        this.slickSlider.on('afterChange', function (event, slick, currentSlideNr) {
                let currentSlide = slick.$slides[currentSlideNr],
                    imageSrc     = $(currentSlide).find('.pdp-zoom__image').attr('src');

                pdpZoom.panImage.attr('src', imageSrc);
            })
            .on('init', function () {
                pdpZoom.addKeyboardEvents();
            })
            .slick({
                infinite:       true,
                speed:          200,
                autoplay:       false,
                initialSlide:   pdpZoom.getClickedGalleryIndex(),
                slidesToShow:   1,
                slidesToScroll: 1,
                fade:           false,
                arrows:         true,
                prevArrow:      `<button type="button" class="pdp-zoom__slider-btn pdp-zoom__slider-btn--left btn btn-primary btn-icon">
                                    <svg class="icon pdp-zoom__slider-icon">
                                        <use xlink:href="#icon-arrow-left"></use>
                                    </svg>
                                </button>`,
                nextArrow:      `<button type="button" class="pdp-zoom__slider-btn pdp-zoom__slider-btn--right btn btn-primary btn-icon">
                                    <svg class="icon pdp-zoom__slider-icon">
                                        <use xlink:href="#icon-arrow-right"></use>
                                    </svg>
                                </button>`,
                customPaging:   function () {
                    return $('<div class="pdp-zoom__slider-dot" />');
                },
                rows:           0,
                swipe:          true,
                dots:           true,
                dotsClass:      'pdp-zoom__slider-dots'
            });
    },

    destroySlickSlider() {
        this.slickSlider
            .slick('unslick')
            .empty();
        this.zoomImageSources = [];
        this.removeKeyboardEvents();
    },

    addKeyboardEvents() {
        $(document).on('keydown.slick', (event) => {
            if (event.keyCode === 37) {
                this.slickSlider.slick('slickPrev');
            }
            if (event.keyCode === 39) {
                this.slickSlider.slick('slickNext');
            }
            if (event.keyCode === 27) {
                this.closeButton.trigger('click');
            }
        });
    },

    removeKeyboardEvents() {
        $(document).off('keydown.slick');
    },

    bindHandler() {
        $(document).on('click', '.pdp__slider-image--zoom', (event) => {
            const $this          = event.target;
            const galleryWrapper = $('.pdp__slider-image--zoom');
            this.archibaldGalleryClickedIndex = galleryWrapper.index($this);

            this.extractImageSources();
            this.addZoomSlides();
            this.initPanImage();
            this.showZoomOverlay();
            this.buildSlickSlider();
        });

        this.closeButton.on('click', () => {
            this.hideZoomOverlay();
            this.hidePanOverlay();
            this.destroySlickSlider();
        });

        this.openPanButton.on('click', () => {
            this.showPanOverlay();
        });

        this.zoomInButton.on('click', () => {
            this.panArea.panzoom('zoom');
        });

        this.zoomOutButton.on('click', () => {
            this.panArea.panzoom('zoom', true);
            if (this.panArea.panzoom('instance').scale === 1) {
                this.hidePanOverlay();
            }
        });

    }
};

$(() => {
    if ($('#product-detail-page').length) {
        pdpZoom.cacheSelectors();
        pdpZoom.bindHandler();
    }
});

export default pdpZoom;
